/**
 * Compares the selected date if earlier or beyond from the date provided
 */
export default ({ value }, isEmailExist) => {
  let pass = true;
  pass = validateMail(value, isEmailExist);

  return pass;
};

const validateMail = (value, isEmailExist) => {
  return isEmailExist === 'false';
};
